import { Box, Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import FieldHelpHint from '../FieldHelpHint';
import Iconify from '../Iconify';
import {
    EVAL_UTILISATION_BUTTON_LABEL,
    EVAL_UTILISATION_EMPTY_LABEL,
    EVAL_UTILISATION_HELP_TEXT,
    EVAL_UTILISATION_TITLE,
} from './evalUtilisationHelpContent';
import '../../css/machines/modeEtConsigne.css';

const hasEvalUrl = (url) => Boolean(url?.trim());

const MachineEvalUtilisationSection = ({
    evalUtilisationUrl,
    canEdit = false,
    onEdit,
}) => {
    const url = evalUtilisationUrl?.trim();
    const showSection = hasEvalUrl(url) || canEdit;

    if (!showSection) {
        return null;
    }

    return (
        <Box className="modeEtConsigne_box">
            <Box className="modeEtConsigne_edit_box">
                <Box className="modeEtConsigne_title_with_hint">
                    <Typography className="modeEtConsigne_title">{EVAL_UTILISATION_TITLE}</Typography>
                    <FieldHelpHint title={EVAL_UTILISATION_TITLE}>
                        {EVAL_UTILISATION_HELP_TEXT}
                    </FieldHelpHint>
                </Box>
                {canEdit && onEdit && (
                    <Iconify
                        className="modeEtConsigne_edit_icon"
                        icon="ic:outline-edit"
                        onClick={onEdit}
                    />
                )}
            </Box>
            {hasEvalUrl(url) ? (
                <Button
                    className="modeEtConsigne_eval_button"
                    variant="contained"
                    component="a"
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    startIcon={<Iconify icon="material-symbols:open-in-new" />}
                >
                    {EVAL_UTILISATION_BUTTON_LABEL}
                </Button>
            ) : (
                <Typography className="modeEtConsigne_dashed_typography">
                    {EVAL_UTILISATION_EMPTY_LABEL}
                </Typography>
            )}
        </Box>
    );
};

MachineEvalUtilisationSection.propTypes = {
    evalUtilisationUrl: PropTypes.string,
    canEdit: PropTypes.bool,
    onEdit: PropTypes.func,
};

export default MachineEvalUtilisationSection;
